<template>
  <div class="default-path">
    <!-- 新增：顶部自定义学习路线栏 -->
    <div class="custom-header-bar">
      <div class="header-left">
        <img class="header-icon" src="@/assets/book.png" alt=""/>
        <span class="header-title">自定义课程文件夹</span>
      </div>
      <button class="edit-btn" :class="{ active: isEditMode }" @click="toggleEditMode">
        {{ isEditMode ? '退出编辑' : '编辑课程路线' }}
      </button>
    </div>

    <!-- 课程列表/无数据状态 -->
    <div v-if="list.length > 0" class="course-list">
      <div class="course-card" v-for="(item,index) in list" :key="index">
        <div class="course-cover">
          <img :src="item.cover" alt=""/>
        </div>
        <div class="course-info">
          <h4>{{item.name}}</h4>
          <div class="course-meta">
            <!--              <span class="meta-tag">{{item.level === 1 ? '初级' : item.level === 2 ? '中级' : item.level === 3 ? '高级' : ''}}技巧</span>-->
          </div>
          <div class="course-footer">
            <span class="meta-study">{{item.see_num}}人已学</span>
            <!-- 编辑模式下显示移出按钮 -->
            <button
                v-if="isEditMode"
                class="remove-btn"
                @click="handleRemoveCourse(item)"
            >
              <img src="@/assets/LIST_ADD.png" alt="">
              移出课程路线
            </button>
            <!--              <span v-else class="meta-free">{{item.level === 1 ? '初级' : item.level === 2 ? '中级' : item.level === 3 ? '高级' : ''}}</span>-->
          </div>
        </div>
      </div>
    </div>

    <!-- 无数据状态 -->
    <div v-else class="empty-state">
      <img class="empty-image" src="@/assets/empty-data.png" alt="暂无数据"/>
      <p class="empty-text">暂无课程数据</p>
    </div>

    <div class="page" v-if="total > 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {collectList, collectDel} from '@/api/api'

  export default {
    name: "index",
    data() {
      return {
        list: [],
        page: 1,
        limit: 10,
        total: 0,
        id: '',
        // 新增：编辑模式状态
        isEditMode: false
      }
    },
    watch: {
      // 监听路由变化
      '$route'(to, from) {
        this.isEditMode = false
        this.id = to.query.id
        this.collectList()
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.collectList()
    },
    methods: {
      handleSizeChange(val) {
        this.limit = val
        this.collectList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.collectList()
      },
      collectList() {
        let params = {
          page: this.page,
          limit: this.limit,
          cate_id: this.id
        }
        collectList(params).then(res => {
          this.list = res.data.list
          this.total = res.data.page.total
        })
      },
      // 新增：切换编辑模式
      toggleEditMode() {
        this.isEditMode = !this.isEditMode
      },
      // 新增：移出课程的方法（你可以在这里调用删除接口）
      handleRemoveCourse(course) {
        this.$confirm('您确定要移除课程吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          collectDel({id: course.news_id, cate_id: this.id}).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.collectList()
          })

        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped lang="less">
  /* 新增：顶部栏样式，1:1还原设计 */
  .custom-header-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: #fff9e6; /* 浅黄色背景 */
    padding: 16px 24px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-sizing: border-box;

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .header-icon {
        width: 48px;
        height: 48px;
        object-fit: contain;
      }

      .header-title {
        font-size: 20px;
        font-weight: 600;
        color: #1e293b;
      }
    }

    .edit-btn {
      background-color: #ff9f1c; /* 橙色按钮 */
      color: #fff;
      border: none;
      border-radius: 8px;
      padding: 12px 32px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background-color: #e68a00;
      }

      /* 编辑模式激活状态 */

      &.active {
        background-color: #3355ff; /* 蓝色退出编辑按钮 */

        &:hover {
          background-color: #2948e0;
        }
      }
    }
  }

  .course-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .course-card {
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #f1f1f1;

      .course-cover {
        width: 100%;
        height: 160px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .course-info {
        padding: 12px 16px;

        h4 {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin: 0 0 8px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }

        .course-meta {
          display: flex;
          gap: 8px;
          margin-bottom: 12px;

          .meta-tag {
            padding: 2px 8px;
            background-color: #eff6ff;
            color: #3a44f7;
            border-radius: 4px;
            font-size: 12px;
          }
        }

        .course-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .meta-study {
            font-size: 12px;
            color: #94a3b8;
          }

          .meta-free {
            font-size: 14px;
            font-weight: 500;
            color: #ef4444;
          }


          .join-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 12px;
            font-size: 14px;
            color: #ffffff;
            font-weight: 500;
            background-color: #3355ff;
            border: none;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          /* 新增：移出课程按钮样式，和设计图一致 */

          .remove-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 12px;
            font-size: 14px;
            color: #ffffff;
            font-weight: 500;
            background-color: #ff3366;
            border: none;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          img {
            width: 20px;
            height: 20px;
          }

          .join-btn:hover {
            background-color: #2948e0;
          }

          .join-btn:active {
            background-color: #223dcc;
            transform: scale(0.98);
          }
        }
      }
    }
  }

  /* 新增：无数据状态样式 */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    text-align: center;

    .empty-image {
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
      object-fit: contain;
      opacity: 0.7;
    }

    .empty-text {
      font-size: 16px;
      color: #94a3b8;
      margin: 0;
    }
  }

  .page {
    margin-top: 30px;
  }
</style>
